'use strict';
import angular from 'angular';
var CredentialEditController = /** @class */ (function () {
    /*@ngInject*/
    function CredentialEditController(Auth, $state, $log, $cookies, $mdToast, $scope, $timeout, Util, CredentialEditService, Upload) {
        this.sortType = 'doctorType';
        this.sortReverse = false;
        this.credentialType = null;
        this.credentialTypes = ['License', 'Other'];
        this.selectedCredentialType = null;
        this.selectedDoctorType = null;
        this.selectedCredential = null;
        this.loadingBar = false;
        this.isFileUploaded = true;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.credentialIdToDelete = null;
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.showAlert = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$scope = $scope;
        this.$log = $log;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.credentialEditService = CredentialEditService;
        this.$mdToast = $mdToast;
        this.Util = Util;
        this.Auth = Auth;
        var self = this;
        self.loadingBar = true;
        if (self.mode != 'Edit') {
            if (self.credentials && self.credentials.length) {
                console.log('2. Credentials Received ->', self.credentials);
            }
            self.credentialEditService.getDoctorTypes()
                .then(function (response) {
                self.doctorTypes = response.data.response.currentPage;
            })
                .finally(function () { return self.loadingBar = false; });
        }
        else {
            var cred = angular.copy(self.credentials);
            self.credentials = [];
            self.selectedCredentialType = cred.credentialType;
            self.credentials.push(cred);
            self.selectedCredential = cred;
            self.credentialEditService.getDoctorTypes().then(function (response) {
                self.doctorTypes = response.data.response.currentPage;
                self.selectedDoctorType = self.getDoctorType(cred.doctorType);
            });
        }
        $scope.$watch('cd.files', function () {
            // self.upload(self.selectedCredential);
        });
        $scope.$watch('cd.credentialForm.cdFile.$error.pattern', function () {
            if (self.credentialForm && self.credentialForm.cdFile && self.credentialForm.cdFile.$error.pattern) {
                self.showAlert = true;
                self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
            }
        });
        $scope.$watch('cd.file', function () {
            if (self.file != null) {
                self.showAlert = false;
                if (self.file.size) {
                    if (self.file.size > 1000000) {
                        self.isFileUploaded = true;
                        self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
                        self.$timeout(function () {
                            self.showAlert = true;
                        }, 0);
                    }
                    if (self.selectedCredentialType != null && self.selectedDoctorType != null) {
                        var cred = angular.copy(self.selectedCredential);
                        self.selectedCredential.status = 'Upload Pending';
                        self.selectedCredential.file = self.file;
                        self.selectedCredential.doctorType = self.selectedDoctorType;
                        self.loadingBar = true;
                        self.$timeout(function () {
                            self.loadingBar = false;
                        }, 300);
                        //self.files = [self.file];
                    }
                    else {
                        alert('Select Credential Type before adding the File');
                    }
                }
                else {
                    self.Util.setPageErrors('Cannot upload empty file', '', self);
                    self.showAlert = true;
                }
            }
        });
        self.log = '';
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.onUpdate({
                $event: {
                    credentials: self.credentials
                }
            });
        });
    }
    CredentialEditController.prototype.uploadCredential = function () {
        var self = this;
        self.upload(self.selectedCredential);
    };
    CredentialEditController.prototype.uploadFile = function () {
        var self = this;
        self.isFileUploaded = false;
    };
    CredentialEditController.prototype.getDownloadUrl = function (credential) {
        var self = this;
        var downloadUrl = "api/account/credentials/" + credential.credentialId + "/download";
        return downloadUrl;
    };
    CredentialEditController.prototype.upload = function (cred) {
        this.Auth.clearAccountCache();
        var self = this;
        console.log('Uploading credential ->', cred);
        if (cred) {
            if (!cred.$error && cred.credentialType != null) {
                var xsrf_token = this.$cookies.get('XSRF-TOKEN');
                self.Upload.upload({
                    url: '/api/account/credentials/' + cred.credentialId,
                    method: 'PUT',
                    headers: {
                        'X-XSRF-TOKEN': xsrf_token
                    },
                    data: {
                        doctorTypeId: cred.doctorType.doctorTypeID,
                        doctorTypeKey: cred.doctorType.doctorTypeKey,
                        file: cred.file
                    }
                }).then(function (resp) {
                    self.$timeout(function () {
                        if (cred.file) {
                            self.log = 'file: ' +
                                resp.config.data.file.name;
                        }
                        self.log = self.log + ', Response: ';
                        console.log(self.log, resp);
                        // self.credentials[0].status = 'PENDING REVIEW';
                        self.loadingBar = false;
                        if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                            if (resp.status === 413) {
                                var errorResponse = resp;
                                errorResponse.data = {
                                    errors: 'Image size exceeds maximum allowed limit. Please upload an image with a smaller file size.'
                                };
                                self.Util.handleApiError(errorResponse, self);
                            }
                            else {
                                self.Util.handleApiError(resp, self);
                            }
                        }
                        else {
                            self.showSimpleToast("Changes have been saved", '');
                            self.Util.resetApiError(self);
                            self.$scope.$emit('credentialUploaded', resp.data);
                            self.credentialBeingEdited = null;
                            self.file = null;
                        }
                    });
                }, function (response) {
                    self.loadingBar = false;
                    if (response.status != 200 || (response.data && response.data.errors)) {
                        self.Util.handleApiError(response, self);
                    }
                }, function (evt) {
                    self.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if (cred.file != null) {
                        self.log = 'progress: ' + self.progressPercentage + '% ' + evt.config.data.file.name
                            + '\n' + self.log;
                    }
                    console.log(self.log);
                });
            }
        }
    };
    CredentialEditController.prototype.getDoctorType = function (doctorDescription) {
        for (var i = 0; i < this.doctorTypes.length; i++) {
            if (this.doctorTypes[i].description == doctorDescription) {
                return this.doctorTypes[i];
            }
        }
    };
    CredentialEditController.prototype.changeCredType = function (credType) {
        var self = this;
        self.selectedCredentialType = credType;
        self.selectedCredential.status = 'Upload pending';
        self.selectedCredential.file = self.file;
        self.selectedCredential.doctorType = self.selectedDoctorType;
        self.upload(self.selectedCredential);
    };
    CredentialEditController.prototype.editCredential = function (credential) {
        var self = this;
        self.cancelDelete();
        this.credentialBeingEdited = credential.credentialId;
        this.mode = 'Edit';
        //if (credential.credentialType == null) {
        //  credential.credentialType = 'Other';
        //}
        this.selectedCredentialType = credential.credentialType;
        this.selectedCredential = credential;
        this.credentialEditService.getDoctorTypes().then(function (response) {
            if (response.status == 200 && response.data.errors.length == 0) {
                self.doctorTypes = response.data.response.currentPage;
                self.selectedDoctorType = self.getDoctorType(credential.doctorType);
            }
        });
    };
    CredentialEditController.prototype.addCredential = function () {
        this.credentials.push({
            id: this.credentials.length + 1,
            credentialType: null,
            fileName: null,
            status: null
        });
    };
    CredentialEditController.prototype.deleteCredential = function (credential) {
        var self = this;
        self.$log.debug('Deleting Credential -> ', credential);
        this.credentialEditService.deleteCredential(credential.credentialId)
            .then(function (response) {
            if (response.status == 200 && response.data.errors.length == 0) {
                self.credentials = self.credentials.filter(function (x) {
                    return x.credentialId != credential.credentialId;
                });
            }
        });
    };
    CredentialEditController.prototype.setDeleteCredentialId = function (id) {
        this.credentialIdToDelete = this.credentialIdToDelete == id ? null : id;
    };
    CredentialEditController.prototype.cancelDelete = function () {
        this.credentialIdToDelete = null;
    };
    CredentialEditController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#cred-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    CredentialEditController.prototype.$onChanges = function (changes) {
        if (changes.credentials) {
            this.credentials = angular.copy(this.credentials);
        }
    };
    return CredentialEditController;
}());
export default CredentialEditController;
//# sourceMappingURL=credential-edit.controller.js.map